import {
  withTranslation,
} from 'react-i18next';

import CrewmemberSocialUserFieldsView from './CrewmemberSocialUserFieldsView';

const TranslatedComponent = withTranslation()(CrewmemberSocialUserFieldsView);

const Component = TranslatedComponent;

export default Component;
